import type {
    INCoreUIKitIconProps
} from "../../../types";
import {
    Path,
    Svg
} from "react-native-svg";

const TRTRIcon = ({
    size = 32,
    style,
    ...props
}: INCoreUIKitIconProps) => {
    const pathScale = 32 / size;

    return <Svg
        height={size}
        width={size}
        style={{
            ...style
        }}
        {...props}
    >
        <Path
            d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z"
            transform={[
                {
                    scale: 1 / pathScale
                }
            ]}
            fill="#ED4C5C"
        />
        <Path
            d="m20.96 19.734.053-2.88-2.88-.853 2.88-.853-.054-2.88 1.76 2.293 2.88-.853L23.84 16l1.76 2.293-2.88-.853-1.76 2.293Z"
            transform={[
                {
                    scale: 1 / pathScale
                }
            ]}
            fill="#fff"
        />
        <Path
            d="M16.638 22.4c-3.52 0-6.346-2.88-6.346-6.4 0-3.52 2.826-6.4 6.346-6.4 1.334 0 2.56.427 3.627 1.12A7.901 7.901 0 0 0 14.292 8c-4.374 0-7.894 3.573-7.894 8s3.52 8 7.894 8c2.4 0 4.533-1.067 5.973-2.72a6.355 6.355 0 0 1-3.627 1.12Z"
            transform={[
                {
                    scale: 1 / pathScale
                }
            ]}
            fill="#fff"
        />
    </Svg>;
};
export default TRTRIcon;
